<template>
<div class="u-margin">
    <div class="u-flex">
        <img v-if="ProductImage" :src="ProductImage" alt="">
        <img v-else class="default__image" src="@/assets/images/no_image.png" alt="">
        <div class="u-padding-top u-padding-left">
            <h3 class="u-margin-bottom-none">
                {{ productGroup.ProductName }} 
                <template v-if="productGroup.ProductColorName || productGroup.ProductColorId">
                - 
                    <template v-if="productGroup.ProductColorName">
                        {{ productGroup.ProductColorName }} 
                    </template> 
                    <template v-if="productGroup.ProductColorId">
                        ({{ productGroup.ProductColorId }})
                    </template>
                </template>
            </h3>
            <p class="u-margin-top-none">{{ productGroup.ProductDescription }} - {{ productGroup.ProductModelNumber }}</p>
        </div>

    </div>

    <div>
        <div class="c-basket-variant c-basket-variant--column">
            <span class="item"></span>
            <span class="item">{{$t('customer.basket.product.size')}}</span>
            <span class="item">{{$t('customer.basket.product.unit_price')}}</span>
            <span class="item">{{$t('customer.basket.product.discount')}}</span>
            <span class="item">{{$t('customer.basket.product.amount')}}</span>
            <span class="item">{{$t('customer.basket.product.total')}}</span>
            <span class="item"></span>
        </div>
        <v-product-variant v-for="variant in productGroup.Variants"
                           :productLine="variant"
                           :productId="productGroup.ProductId"
                           :key="variant.ProductVariantId"
                           @outOfStock="outOfStock"
                           @inStock="inStock">
        </v-product-variant>
    </div>

</div>
</template>

<script>
    import VProductVariant from '@/components/basket/ProductVariant'

    export default {
        components: {
            VProductVariant
        },
        props: {
          productGroup: Object
        },
        computed: {
            ProductImage() {
                let image = null;
                if (this.productGroup.ProductImages && this.productGroup.ProductImages.length) {
                    image = this.productGroup.ProductImages[0].replace('[WIDTH]', '170').replace('[HEIGHT]', '140');
                }
                return image;
            }
        },
        methods: {
            outOfStock(variantId){
                this.$emit('outOfStock', variantId);
            },
            inStock(variantId){
                this.$emit('inStock', variantId);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .default__image {
        width: 140px;
        height: 140px;
    }
</style>



// WEBPACK FOOTER //
// src/components/basket/Product.vue